    <h3>Personajes</h3>
    <hr>
    <ul>
        <li *ngFor="let personaje of personajes">{{ personaje.nombre }} - {{ personaje.poder | number}}</li>
    </ul>